// extracted by mini-css-extract-plugin
export var button = "_nc-2";
export var card = "_nc-0";
export var closeButtonContainer = "_nc-3";
export var iconContainer = "_nc-1";